const applicationRoutes = {
  authorizedRoot: '/',
  account: {
    myProfile: '/my-profile',
    login: '/login',
    twoFactorLogin: '/two-factor',
    accessDenied: '/access-denied',
    logout: '/logout',
    resetPassword: '/reset-password',
    confirmEmail: '/confirm-email',
    forgotPassword: '/forgot-password',
    thirdPartyPaymentDetailsViewer: '/thirdPartyPaymentDetailsViewer'
  },
  admin: {
    root: '/admin',
    users: '/admin/users',
    activityManagement: '/admin/activities',
    crmManagement: '/admin/crm',
    addUser: '/admin/users/add',
    editUser: '/admin/users/edit',
    announcement: '/admin/announcements',
    quickDocuments: '/admin/quickDocuments',
    passThrough: '/admin/passthrough',
    emailSignatures: '/admin/emailSignatures',
    itinerarySignatures: '/admin/itinerarySignatures',
    folioEmailList: '/admin/folioEmailList',
    systemManagement: '/admin/systemManagement'
  },

  reporting: {
    bookingReport: '/reporting/BookingReport',
    checkoutReport: '/reporting/CheckoutReport',
    agentActivityReport: '/reporting/AgentActivityReport',
    agentActivityReportV2: '/reporting/AgentActivityReportV2',
    folioActivityReport: '/reporting/FolioAgentReport',
    clientEmailReport: '/reporting/ClientEmailReport',
    issueTrackingReport: '/reporting/IssueTrackingReport',
    reconciliationReport: '/reporting/ReconciliationReport',
    audits: '/reporting/Audits'
  },

  agent: {
    activityInquiry: '/agent/activityinquiry',
    obtInquiry: '/agent/obt-inquiry',
    inbox: '/agent/emails',
    inboxLegacy: '/agent/emailsOld',
    inboxCoordinator: '/agent/emailmanager',
    emailEdit: '/agent/emails/edit',
    folioEdit: '/agent/emails/folio',
    ReconciledEdit: '/agent/emails/reconciliation',
    activityReport: '/agent/activityreport',
    activityFolioV2: '/agent/reconciliation',
    folioTableNew: '/agent/folio-table-new',
    folioRequests: '/agent/folio-requests',
    invoiceGroup: '/agent/invoiceGroup'
  },
  mir: {
    mirFileReport: '/mir/file-report',
    mirActivityReport: '/mir/activity-report',
    mirAgentError: '/mir/agent-error'
  },
  crm: {
    brands: { list: '/crm/hotel-brands' },
    address: { list: '/crm/address' },
    hotelsNew: {
      list: '/crm/hotelCrm',
      rateImport: '/crm/hotel-rate-import'
    },
    company: {
      list: '/crm/legacy',
      add: '/crm/legacy/add',
      edit: '/crm/legacy/edit'
    },
    leads: {
      list: '/crm/leads'
    },
    postmark: {
      list: '/crm/postmark'
    },
    companiesNew: {
      list: '/crm/companies'
    },
    companyProject: {
      list: '/crm/companyprojects',
      email: '/companyprojects/projectIntake',
      edit: '/crm/companyprojects/edit',
      dashboard: '/crm/groupdashboard'
    },
    obtUsers: '/crm/obt-users',
    companyContact: '/crm/company-contact',
    taxRates: '/crm/tax-rates'
  },
  support: {
    request: '/support'
  },
  groups: {
    projectContainers: '/groups/project-containers',
    projectDashboard: '/groups/project-dashboard',
    bookings: '/groups/bookings',
    hotelSearch: '/groups/hotel-search'
  }
};
export default applicationRoutes;
